import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Box, Button } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './general-modal.css';

function GeneralModal({
	open = false,
	onClose,
	genText,
	children,
	btn1Text,
	btn2Text,
	btn1OnClick,
	btn2OnClick,
	btn2Disabled,
	width,
	minWidth,
	maxHeight,
	no2btn,
	signedStatus,
	genTextClassName,
	showCloseIcon,
	minHeight,
	overflow,
	overflowX,
	customStyle,
	btn1BorderColor,
	btn1Color,
	btn1Width,
	btn2Width,
	paddingTop,
	btn1BackgroundColor,
	btn2Flex,
	btn1Flex,
	padding,
	breakWord = false
}) {
	return (
		<Modal open={open} onClose={() => {}} className='gen-modal-container'>
			<Box
				className='gen-modal-content'
				sx={{
					overflow: overflow || 'auto',
					overflowX: overflowX || 'visible',
					width: width || '358px',
					maxHeight,
					minWidth,
					minHeight,
					padding: padding || '32px',
					paddingTop: paddingTop || '45px'
				}}
			>
				{genText ? (
					<p
						id='gen-modal-message'
						className={genTextClassName || 'semiBold8'}
						style={breakWord ? { wordBreak: 'break-word' } : {}}
					>
						{genText}
					</p>
				) : null}

				{children}

				<div
					style={customStyle ? { ...customStyle } : {}}
					className='gen-modal-btns'
				>
					{btn1Text && (
						<Button
							variant='contained'
							id='gen-modal-btn'
							onClick={btn1OnClick}
							sx={{
								minWidth: btn1Width,
								height: '20px',
								flex: btn1Flex || 1,
								padding: '17px 20px',
								borderRadius: '8px',
								backgroundColor: btn1BackgroundColor || 'transparent',
								border: `2px solid ${btn1BorderColor || '#b6d423'}`,
								color: btn1Color || '#b6d423',
								marginTop: '20px',
								fontSize: '16px',
								'&:hover': {
									backgroundColor: 'transparent'
								}
							}}
						>
							<div className='medium5'>{btn1Text || 'Skip'}</div>
						</Button>
					)}

					{!no2btn && signedStatus !== 'Signed' && (
						<Button
							variant='contained'
							id='gen-modal-btn'
							onClick={btn2OnClick}
							disabled={btn2Disabled}
							sx={{
								height: '40px',
								flex: btn2Flex || 1,
								width: btn2Width || 'auto',
								padding: '17px 20px',
								borderRadius: '8px',
								backgroundColor: '#b6d423',
								color: '#000',
								boxShadow: 'none',
								marginTop: '20px',
								fontSize: '16px',
								'&:hover': {
									backgroundColor: '#b6d423',
									boxShadow: 'none'
								},
								'&.Mui-disabled': {
									backgroundColor: '#b6d423',
									opacity: '0.7'
								},
								'&.right-corner': {
									position: 'absolute',
									bottom: '20px',
									right: '20px'
								}
							}}
							className={customStyle?.rightCorner ? 'right-corner' : ''} // Conditionally applying the right-corner class based on props
						>
							<div className='medium5'>{btn2Text || 'Next'}</div>
						</Button>
					)}
				</div>

				{
					signedStatus === 'Signed' && <div style={{marginTop: '12px'}}>
						<p style={{textAlign: 'center'}}><span style={{color: 'red'}}><InfoOutlinedIcon /></span> You can not update signed recipient </p>
					</div>
				}

				{showCloseIcon && (
					<Box position={'absolute'} right={'20px'} top={'20px'}>
						<Box className='pointer-css' onClick={onClose}>
							<HighlightOffIcon
								sx={{
									color: '#8e8e8e',
									opacity: 0.7
								}}
							/>
						</Box>
					</Box>
				)}
			</Box>
		</Modal>
	);
}

export default GeneralModal;

GeneralModal.propTypes = {
	open: PropTypes.any,
	onClose: PropTypes.any,
	genText: PropTypes.any,
	children: PropTypes.any,
	btn1Text: PropTypes.any,
	btn2Text: PropTypes.any,
	btn1OnClick: PropTypes.any,
	btn2OnClick: PropTypes.any,
	btn2Disabled: PropTypes.any,
	width: PropTypes.any,
	minWidth: PropTypes.any,
	maxHeight: PropTypes.any,
	no2btn: PropTypes.any,
	genTextClassName: PropTypes.any,
	showCloseIcon: PropTypes.any,
	minHeight: PropTypes.any,
	overflow: PropTypes.any,
	overflowX: PropTypes.any,
	customStyle: PropTypes.any,
	btn1BorderColor: PropTypes.any,
	btn1Color: PropTypes.any,
	signedStatus: PropTypes.any,
	btn1Width: PropTypes.any,
	btn2Width: PropTypes.any,
	paddingTop: PropTypes.any,
	btn1BackgroundColor: PropTypes.any,
	btn2Flex: PropTypes.any,
	btn1Flex: PropTypes.any,
	padding: PropTypes.any,
	breakWord: PropTypes.any
};
